import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ConfigService } from '../provider/config.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Events } from '../provider/events.service';
import { LoadingController, ModalController, NavController, Platform, ToastController } from '@ionic/angular';
import { ApiService } from '../provider/api.service';
import { AuthService } from '../services/auth.service';
import { AccountService } from '../provider/account.service';
import { endpoints } from '../constant/endpoints';
import { first } from 'rxjs';
import { OtpVerificationPage } from '../accounts/otp-verification/otp-verification.page';
import { Router } from '@angular/router';
// import { ActionSheetController } from '@ionic/angular'; // <-- Import ActionSheetController


@Component({
    selector: 'app-logon',
    templateUrl: './logon.page.html',
    styleUrls: ['./logon.page.scss'],
})
export class LogonPage implements OnInit {
    settings: any = {};
    responseData: any;
    country_iso_code: string = "KW";
    loginForm: FormGroup;
    loading: boolean = false;
    error_messages = {
        'phone': [
            { type: 'required', message: 'phone_is_required' },
            { type: 'pattern', message: 'please_enter_a_valid_phone_number' },
        ],
        'password': [
            { type: 'required', message: 'password_is_required' },
            { type: 'minlength', message: 'password_length_must_be_longer_or_equal_to_6_characters' },
            { type: 'maxlength', message: 'password_length_must_be_lower_or_equal_to_30_characters' },
        ]
    }
    public showPwd: boolean = false;
    passwordType: any = 'password';
    pushToken: string = 'demo';
    historyRoute: string = 'signin';
    branches: any = [];
    branch_id: number;
    constructor(
        private events: Events,
        private router: Router,
        private platform: Platform,
        private formBuilder: FormBuilder,
        private modalCtrl: ModalController,
        private loadingCtrl: LoadingController,
        private toastCtrl: ToastController,
        private translate: TranslateService,
        private apiService: ApiService,
        private authService: AuthService,
        private accountService: AccountService,
        private configService: ConfigService,
    ) { }

    ngOnInit() {
        this.configService.getAppSettings()
            .then(async (settingData: any) => {
                this.settings = JSON.parse(settingData);
                this.translate.setDefaultLang(this.settings.appLanguage);
                this.translate.use(this.settings.appLanguage);
            });
        this.accountService.getIPAddress()
            .then((result: any) => {
                if (result.status === 'success') {
                    this.country_iso_code = result.countryCode;
                }
            }
            );
        this.platform.ready().then(() => {
            this.initializeForm();

        });
    }

    initializeForm() {
        const isAndroid = this.platform.is('android');
        const isIOS = this.platform.is('ios');
        const isCapacitor = this.platform.is('capacitor');

        const deviceType = isAndroid ? 'android' : isIOS ? 'ios' : 'web';
        const deviceToken = isCapacitor ? 'demo' : 'demo';
        /**  ------------60340997--------  ----------123456--------   **/
        this.loginForm = this.formBuilder.group({
            phone: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(8),
                Validators.maxLength(10),
                Validators.pattern('^[0-9]$'),
            ])),
            //country_iso_code: new FormControl(this.country_iso_code, Validators.compose([])),
            password: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(30),
            ])),
            device_type: new FormControl(deviceType),
            device_token: new FormControl(deviceToken),
        });
    }
    onSubmit = () => {
        this.loading = true;
        this.showLoading();
        console.log(this.loginForm.value);
        this.apiService
            .post(endpoints.login, this.loginForm.value)
            .pipe(first())
            .subscribe(async (response) => {
                this.loading = false;
                this.hideLoading();
                console.log(response);
                if (response.success) {
                    this.authService.setAuthToken(response.data.customer.session_token);
                    this.authService.setAuthUser(response.data.customer);
                    this.authService.setAuthVerify(response.data.customer.is_verified);
                    if (response.data.customer.is_verified) {
                        this.toastMessage(response.message);
                        this.settings.currentUser = response.data.customer;
                        this.configService.setStorage('appSettings', this.settings);
                        this.events.publish('user:login', { user: response.data.customer, time: new Date() });
                        this.modalCtrl.dismiss(response.data.customer, 'close');
                    } else {
                        let otpModal = await this.modalCtrl
                            .create({
                                component: OtpVerificationPage,
                                componentProps: {
                                    phone: this.loginForm.value.phone,
                                    country_iso_code: this.country_iso_code,
                                    otp_sent: true
                                }
                            });
                        otpModal.onDidDismiss()
                            .then((result: any) => {
                                console.log(result);
                                if (result.data) {
                                    this.authService.setAuthVerify('true');
                                    this.events.publish('user:login', { user: response.data.customer, time: new Date() });
                                    this.modalCtrl.dismiss(response.data.customer, 'close');
                                } else {
                                    this.modalCtrl.dismiss(null, 'cancel');
                                }
                            }
                            );
                        return otpModal.present();
                    }
                } else {
                    this.toastMessage(response.message);
                }
            }, (err) => {
                this.loading = false;
                this.hideLoading();
                console.log(err.error);
                if (err.error.message) {
                    console.log(err.error.message);
                    this.toastMessage(err.error.message);
                } else {
                    Object.keys(err.error).forEach((key) => {
                        let errorArray = err.error[key];
                        Object.keys(errorArray).forEach((index) => {
                            this.toastMessage(errorArray[index]);
                        });
                    });
                }
            });
    }


    public showPassword = () => {
        this.showPwd = !this.showPwd;
        if (this.passwordType === 'text') {
            this.passwordType = 'password';
        } else {
            this.passwordType = 'text';
        }
    }

    navigateToPage = (page: any) => {
        this.modalCtrl.dismiss(null, 'cancel');
        this.router.navigate([page]);
    }
    resetPassword = async () => {
        if (this.loginForm.value.phone) {
            this.showLoading();
            this.apiService
                .post(endpoints.resetPassword, { 'phone': this.loginForm.value.phone })
                .pipe(first())
                .subscribe(async (result) => {
                    this.hideLoading();
                    if (result.success) {
                        this.toastMessage(result.message);
                    }
                }, (err) => {
                    this.hideLoading();
                    console.log(err);
                });
        } else {
            this.toastMessage('phone_number_is_required');
        }
    }
    toastMessage = async (msg: string) => {
        await this.toastCtrl.create({
            message: this.translate.instant(msg),
            duration: 3000,
            position: 'middle',
            color: 'primary'
        }).then((toastElem) => toastElem.present());
    }
    showLoading = async () => {
        this.loadingCtrl.create({
            message: this.translate.instant('please_wait'),
            cssClass: 'loader_class',
            duration: 3000,
        }).then(a => {
            a.present().then(() => {
                console.log('presented');
            });
        });
    }
    hideLoading = async () => {
        setTimeout(async () => {
            try {
                this.loadingCtrl.dismiss();
            } catch (error) {
                console.log(error);
            }
        }, 1000);
    }
}
